var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app h-screen"},[_c('RouterView',{staticClass:"Simple"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }